import { PROCESS_STEP_STATUS, PROCESS_STEP_STATUSES } from './constants';

/** Return `status` when it is a known badge state, else the default state. */
export const resolveStepStatus = (status) =>
    (PROCESS_STEP_STATUSES.has(status) ? status : PROCESS_STEP_STATUS.DEFAULT);

// Stable key per step: explicit id, else the position.
export const stepKey = (step, index) => (step?.id != null ? String(step.id) : `step-${index}`);
